<template>
    <vs-popup
            class="partial-modal"
            title="Gedeeltelijk terugstorten"
            :active.sync="showPopup"
            v-if="activeOrder !== null"
    >

        <vs-list>
            <vs-list-item v-for="detail in activeOrder.details" :key="detail.id">
                <template slot="title">
                    <p>
                        <vs-checkbox v-model="selected" :vs-value="detail">{{ detail.product.name}}</vs-checkbox>
                    </p>
                    <vs-input-number v-if="itemSelected(detail)" min="0" :max="detail.quantity" :vs-value="detail.id"
                                     v-model="selectedItem(detail).quantity"/>
                </template>
                <template slot="subtitle">
                    <ul class="pl-4">
                        <li v-for="addon in detail.addons" :key="addon.id">
                            <vs-checkbox v-if="addon.price > 0" v-model="selectedAddons" :vs-value="addon">{{ addon.name
                                }} {{ addon.price}}
                            </vs-checkbox>
                        </li>
                    </ul>
                </template>
                € {{ (detail.quantity * detail.product.price).toFixed(2)}}
            </vs-list-item>
            <vs-list-item>
                <template slot="title">

                    <p>
                        <vs-checkbox v-if="activeOrder.delivery_fee > 0" v-model="refundDeliveryCost"
                                     :vs-value="activeOrder.delivery_fee">Bezorgkosten
                        </vs-checkbox>
                    </p>
                </template>
                {{ activeOrder.delivery_fee}}
            </vs-list-item>
            <vs-list-item>
                <template slot="title">
                    Transactiekosten
                </template>
                {{ activeOrder.transaction_fee}}
            </vs-list-item>
            <vs-list-item>
                <template slot="title">
                    Totaal
                </template>
                {{ activeOrder.price}}
            </vs-list-item>
            <vs-list-item>
                <template slot="title">
                    <p>Voucher?</p>
                </template>
                <p>
                    <vs-switch v-model="voucher">Voucher?</vs-switch>
                </p>
            </vs-list-item>
            <vs-list-item>
                <template slot="title">
                    <p>Compensatie door Hebtrek?</p>
                </template>
                <p>
                    <vs-switch v-model="refundByHebtrek">Compensatie door Hebtrek?</vs-switch>
                </p>
            </vs-list-item>

        </vs-list>
        <vs-input v-model="reason" class="spacing w-full mb-2" label="Reden (Verplicht)"></vs-input>
        <vs-input v-model="total" class="spacing w-full mb-2" label="Bedrag (Optioneel)"></vs-input>

        <template>

            <vs-button class="mr-3 w-full mb-2 vs-con-loading__container" id="refund-button" ref="loadableButton"
                       @click="partiallyRefundOrder" :disabled="!allowRefund">{{ refund }}
            </vs-button>
        </template>
    </vs-popup>
</template>

<script>
    export default {
        data() {
            return {
                massActive: false,
                showPopup: false,
                activeOrder: null,
                selected: [],
                voucher: false,
                selectedAddons: [],
                details: [],
                reason: "",
                detailCache: [],
                refundDeliveryCost: false,
                refundByHebtrek: false,
                total: 0.00
            };
        },
        computed: {
            refund() {
                console.log(this.totalRefund);
                if (this.totalRefund > 0) {
                    return 'Stort € ' + this.totalRefund + ' terug naar de klant';
                }

                if (this.totalRefund == 0) {
                    return 'Je hebt nog niks geslecteerd!';
                }

                if (this.totalRefund > parseFloat(this.activeOrder.price)) {
                    return "Het bedrag mag niet groter zijn dan de bestelwaarde";
                }

                if (this.voucher === true) {
                    return 'Maak voucher van € ' + total.toFixed(2) + ' en stuur naar de klant';
                }
                return 'Stort € ' + this.totalRefund + ' terug naar de klant';
            },
            totalRefund() {
                let total = 0.00;
                this.selected.map(item => {
                    total += parseInt(item.quantity) * item.price;
                });
                this.selectedAddons.map(addon => {
                    total += parseFloat(addon.price);
                });

                if (this.refundDeliveryCost) {
                    total += parseFloat(this.activeOrder.delivery_fee);
                }

                if (this.total > 0.01 && this.total <= parseFloat(this.activeOrder.price)) {
                    total = parseFloat(this.total);
                }

                return total.toFixed(2);
            },
            allowRefund() {
                let total = 0.00;
                this.selected.map(item => {
                    console.log(item.quantity);
                    total += parseInt(item.quantity) * item.price;
                });
                this.selectedAddons.map(addon => {
                    total += parseFloat(addon.price);
                });

                if (this.refundDeliveryCost) {
                    total += parseFloat(this.activeOrder.delivery_fee);
                }

                if (this.total > 0.01 && this.total <= parseFloat(this.activeOrder.price)) {
                    total = this.total;
                }

                if (this.reason === "") {
                    total = 0;
                }
                return total >= 0.01;
            }
        },
        watch: {
            showPopup() {
                this.selected = [];
                this.selectedAddons = [];
            }
        },
        methods: {
            selectDetail(detail) {

            },
            partiallyRefundOrder() {
                if (!this.voucher) {
                    this.$vs.loading({
                        background: 'primary',
                        color: '#fff',
                        container: "#refund-button",
                        scale: 0.45
                    });
                    let data = {
                        _method: 'POST',
                        order_id: this.activeOrder.id,
                        price: this.totalRefund,
                        refund_by_hebtrek: this.refundByHebtrek,
                        selected: this.selected,
                        reason: this.reason
                    };
                    this.$http
                        .post("v1/payment/refund", data, {
                            headers: {
                                Authorization:
                                    "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
                            },
                        })
                        .then(() => {
                            this.showPopup = false;
                            this.$vs.loading.close("#refund-button > .con-vs-loading")
                            this.$util.notify('Terugstorting gelukt', 'Je hebt € ' + this.totalRefund + ' teruggestort naar de klant', this.$vs);
                        })
                        .catch((error) => {
                            this.$util.logError(error, this.$vs);
                            this.$vs.loading.close("#refund-button > .con-vs-loading")
                        });
                } else {
                    this.$util.notify('Voucher aangemaakt', 'Je hebt € ' + this.totalRefund + ' voucher naar de klant gestuurd', this.$vs);
                }
            },

            getAmount(detail) {
                return amount;
            },
            itemSelected(detail) {
                var selected = false;
                if (this.selected.length > 0) {
                    this.selected.map(item => {
                        if (item.id == detail.id) {
                            selected = true;
                        }
                    });
                }
                return selected;
            },
            selectedItem(detail) {
                console.log(detail);
                var selected = null;
                if (this.selected.length > 0) {
                    this.selected.map(item => {
                        if (item.id === detail.id) {
                            selected = item;
                        }
                    });
                }
                return selected;
            }
        },
        mounted() {
            this.isMounted = true;
            this.$vs.loading.close("#refund-button > .con-vs-loading")
            this.$events.listen("open-partial-modal", (order) => {
                this.activeOrder = order;
                this.showPopup = true;
                this.details = order.details;
            });
        },
    };
</script>

<style>
    .boxStyles {
        margin-right: 0.5em;
    }

    .con-vs-checkbox {
        padding-top: 7px;
    }

    .vs-input-number-size-null {
        width: 60px;
        margin-left: 50px;
    }

    .spacing {
        margin: 15px 0;
    }
</style>>
